export enum FundsMaturitySelection {
  APPROVED = 'Approved',
  MATURED_VERIFIED = 'Matured (Verified)',
  MATURED_UNVERIFIED = 'Matured (Unverified)',
  INSUFFICIENT = 'Insufficient',
  NOT_MATURED_DATE = 'Not matured (Date)',
  N_A = 'N/A',
  OTHER = 'Other',
}
